'use strict';

var extractHex = {};

exports.__exports = extractHex;
//# sourceMappingURL=extractHex.cjs.map
